export default __webpack_public_path__ + "static/media/hht1_ep20_book_wp_02.14e331d3.jpg";